import script from "./DotLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./DotLoader.vue?vue&type=script&lang=ts&setup=true"

import "./DotLoader.vue?vue&type=style&index=0&id=40e5660a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40e5660a"]])

export default __exports__